import { render, staticRenderFns } from "./NuevaImagen.vue?vue&type=template&id=827f56d2"
import script from "./NuevaImagen.vue?vue&type=script&lang=js"
export * from "./NuevaImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports